<template>
  <b-container>
    
    <cargo-edit-data
      :cargo="model"
      :id="id"
      :companyId="companyId"
      :modal="false"
      :modelstate="modelstate"
      :permission="permissions"
    ></cargo-edit-data>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "CargoEdit",
  components: {
    CargoEditData: () =>
      import("@/components_rms/tracking/cargo/CargoEditData.vue"),
    CargoCrudData: () =>
      import("@/components_rms/tracking/cargo/CargoCrudData.vue"),
  },
  props: {
    id: String,
    companyId: String,
  },
  data() {
    return {
      model: {
        cargoActive: true,
        clientName: "",
        companyId: "",
        companyBranchName: "",
        dateAttendance: "",
        dateDeliveryForecast: "",
        destinationCityName: "",
        originCityName: "",
        status: 1,
        vehicleTypeName: "",
        weight: 0.0,
        additionalInformation: "",
        reasonForChangingTheAttendanceDate: "",
        dateAttendanceChange: "",
        hourAttendanceChange: "",
        reasonForStatusChange: "",
        reasonForStatusChangeText: "",
        transportNumber: "",
        shipperDocument: "",
        shipperName: "",
        serviceTakerDocument: "",
        serviceTakerName: "",
        cargoPath: [],
      },
      permissions: 0,
      modelstate: {},
    };
  },

  methods: {},
};
</script>
